import "numeral/locales";
import numeral from "numeral/numeral";

numeral.locale("pt-br");
numeral.defaultFormat("0,0.00");
window.numeral = numeral;

export default numeral;